<template>
    <div class="d-flex flex-column align-center wrapper pt-12">
        
        <h2>Καλησπέρα</h2>
        <p class="text-center px-2">Θα μας βοηθούσατε πολύ εάν μπορείτε να μας παρέχετε μερικά σχόλια και παρατηρήσεις, ώστε να βελτιώσουμε την υπηρεσία μας.</p>
        <p class="text-center">Συγκεκριμένα, θα θέλαμε να μας πείτε αν:</p>
        <h1 class="font-weight-bold">-A-</h1>
        <v-checkbox v-model="check1" color="rgb(0,170,221)" class="px-2" label="Υπήρχε κάποιο τεχνικό πρόβλημα (παρακαλώ περιγράψτε)"></v-checkbox>
        <v-text-field label="Περιγραφή" v-if="check1"></v-text-field>
        <h1 class="font-weight-bold">-B-</h1>
        <v-checkbox v-model="check2" color="rgb(0,170,221)" label="Δεν απάντησαν οι γιατροί που καλέσατε"></v-checkbox>
        <v-text-field label="Περιγραφή" v-if="check2"></v-text-field>
        <h1 class="font-weight-bold">-Γ-</h1>
        <v-checkbox v-model="check3" class="px-2" color="rgb(0,170,221)" label="Υπήρχε άλλος λόγος για την αδυναμία σύνδεσης (παρακαλώ περιγράψτε)"></v-checkbox>
        <v-text-field label="Περιγραφή" v-if="check3"></v-text-field>
         <v-btn depressed rounded class="white--text text-capitalize mb-2" color="rgb(0,170,221)">
             Υποβολή
         </v-btn>
        <v-spacer></v-spacer>

        <div class="footer d-flex justify-space-between py-6">
            <img src="@/assets/logoWhite.png" alt="">
            <p class="mb-0 mr-1 white--text text-right">Με εκτίμηση, Η ομάδα του <span class="font-weight-bold">Doctor Next 2 Me.</span></p>
        </div>
       
        
    </div>
</template>

<script>
export default {
    data: () => ({
        check1: false,
        check2: false,
        check3: false
    })
}
</script>

<style scoped>
.wrapper{
    height:100vh;
}

.footer{
    background-color: rgb(0,170,221);
    width: 100%;
    -webkit-box-shadow: 0px -7px 6px -1px rgba(0,0,0,0.11);
-moz-box-shadow: 0px -7px 6px -1px rgba(0,0,0,0.11);
box-shadow: 0px -7px 6px -1px rgba(0,0,0,0.11);
}

img{
    height:60px;
}
</style>